import React from 'react';
import { StyledClients, StyledContentClients } from './Clients.style';
import ClientsSlider from './ClientsSlider';
import SectionTitle from '../../../SectionTitle.style';

function Clients() {
  return (
    <StyledClients id="clients">
      <StyledContentClients>
        <SectionTitle>Our Clients</SectionTitle>
      </StyledContentClients>
      <ClientsSlider />
    </StyledClients>
  );
}

export default Clients;
